import { DatePipe } from '@angular/common';
import { AfterViewInit, Component, ElementRef, inject, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NZ_MODAL_DATA, NzModalFooterDirective, NzModalRef, NzModalService, NzModalTitleDirective } from 'ng-zorro-antd/modal';
import { NzTableCellDirective, NzTableComponent, NzTableModule, NzTbodyComponent, NzTheadComponent, NzThMeasureDirective, NzTrDirective } from 'ng-zorro-antd/table';
import { PauseService } from 'src/app/private/services/pause.service';
import { ProductionPauseDto } from 'src/app/shared/dto/production-pause.dto';
import { TITLE_TABLE_SIZE } from 'src/app/core/constants/style';
import { ProductionOrderProcessDto } from 'src/app/shared/dto/production-order-process.dto';
import { ModalCreatePauseComponent } from '../modal-create-pause/modal-create-pause.component';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzIconModule, NzIconService } from 'ng-zorro-antd/icon';
import { IconDefinition } from '@ant-design/icons-angular';
import { FormOutline } from '@ant-design/icons-angular/icons';
import { Subject, takeUntil } from 'rxjs';
import { UserLoggedService } from 'src/app/core/services/userLogged.service';
import _ from 'lodash';
import { UserDto } from 'src/app/shared/dto/user.dto';
import { DefaultComponent } from 'src/app/shared/services/view.service';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';

const icons: IconDefinition[] = [
    FormOutline
];
@Component({
    selector: 'app-modal-watch-pauses',
    templateUrl: './modal-watch-pauses.component.html',
    styleUrls: ['./modal-watch-pauses.component.scss'],
    standalone: true,
    imports: [
        NzTableModule,
        NzTableComponent,
        NzTheadComponent,
        NzTrDirective,
        NzModalTitleDirective,
        NzTableCellDirective,
        NzThMeasureDirective,
        NzTbodyComponent,
        NzModalFooterDirective,
        NzEmptyModule,
        DatePipe,
        NzToolTipModule,
        NzDividerModule,
        NzIconModule,
        LoaderComponent
    ]
})
export class ModalWatchPausesComponent extends DefaultComponent implements OnInit, AfterViewInit, OnDestroy {

    isLoading: boolean = true;
    pauses: ProductionPauseDto[] = [];
    tableHeight!: number;
    orderProcess!: ProductionOrderProcessDto;
    userLogged!: UserDto;

    @ViewChild('modalContent') private readonly _modalContent!: ElementRef;

    private readonly iconService = inject(NzIconService);
    private readonly pauseService = inject(PauseService);
    private readonly modalRef = inject(NzModalRef);
    private readonly modalService = inject(NzModalService);
    private readonly message = inject(NzMessageService);
    private readonly userLoggedService = inject(UserLoggedService);

    private unsubscribe$ = new Subject<void>();

    constructor(
        @Inject(NZ_MODAL_DATA) public data: { nzTitle: string, orderProcess: ProductionOrderProcessDto }
    ) {
        super('pauses', '');
        this.orderProcess = data?.orderProcess;
    }

    async ngOnInit() {
        this.iconService.addIcon(...icons);
        this.userLogged = _.cloneDeep(this.userLoggedService.userLogged);

        await this.pauseService.setupWebSocketByProcessId(this.orderProcess.id!);
        this.pauseService.pausesByProcessId$
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe({
                next: (pauses) => {
                    this.pauses = _.cloneDeep(pauses);
                },
                error: () => {
                    this.message.error('Error cargando pausas');
                }
            });

        this.isLoading = false;
    }

    async ngAfterViewInit(): Promise<void> {
        setTimeout(() => {
            this.tableHeight =
                (this._modalContent.nativeElement as HTMLImageElement)
                    .clientHeight - TITLE_TABLE_SIZE;
        });
    }

    ngOnDestroy(): void {
        this.pauseService.disconnectWebSocketByProcessId();
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    handleCancel(): void {
        this.modalRef.close();
    }

    milisecondsToFormatTime(start: Date, end: Date): string {
        const millisec: number = end.getTime() - start.getTime();
        let seconds: number = +(millisec / 1000).toFixed(0);
        let minutes: number = Math.floor(seconds / 60);
        let hours: number = 0;

        if (minutes > 59) {
            hours = Math.floor(minutes / 60);
            minutes = minutes - hours * 60;
        }

        seconds = Math.floor(seconds % 60);

        if (hours > 0) {
            return `${hours >= 10 ? '' : '0'}${hours} : ${minutes >= 10 ? '' : '0'}${minutes} : ${seconds >= 10 ? '' : '0'}${seconds}`;
        }

        return `${minutes >= 10 ? '' : '0'}${minutes} : ${seconds >= 10 ? '' : '0'}${seconds}`;
    }

    editPause(pause: ProductionPauseDto) {
        const modal = this.modalService.create({
            nzContent: ModalCreatePauseComponent,
            nzStyle: { width: '70%', top: '20%' },
            nzBodyStyle: { height: '50vh' },
            nzClosable: false,
            nzKeyboard: false,
            nzFooter: null,
            nzData: {
                nzTitle: `Editar pausa - Proceso ${this.orderProcess?.id} | ${this.orderProcess?.description} | Pausa ${pause?.id}`,
                orderProcessId: this.orderProcess?.id,
                orderProcessDescription: this.orderProcess?.description,
                previousStatusId: this.orderProcess?.statusId,
                machineId: this.orderProcess?.machineId,
                pause: pause
            }
        });

        modal.componentInstance?.emitService.subscribe(async (response: ProductionPauseDto) => {
            if (response) {
                this.message.success('Pausa actualizada correctamente');
            }
        });
    }

    canReadSubKey(permissionSubKey: string): boolean {
        const permissionMainKey: string = 'pauses';

        return this.permissionService.canRead(permissionMainKey, `${permissionSubKey}`);
    }

}
